import {
  Box,
  Container,
  FormControl,
  Grid,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const LoadingAndUnLoading = ({
  handleChangePdLoadingUnloading,
  handleLoadingUnloadDelete,
  handleIncrementLoadingUnloading,
  loadingUnLoadingCount,
}) => {
  const classes = useStyles(loadingUnLoadingCount);

  return (
    <>
      <>
        {loadingUnLoadingCount?.map((item, i) => (
          <Box className="loadingUnloadingDetalis desktop  " key={i}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
                padding: "15px 10px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "10px",
                }}
              >
                <Typography variant="span">
                  <HomeIcon />
                </Typography>
                <Typography variant="h6">
                  Loading And UnLoading Details
                </Typography>
              </Box>
              <Box>
                {i !== 0 ? (
                  <button
                    className="quote_loadingUn_btn"
                    onClick={() => handleLoadingUnloadDelete(i)}
                  >
                    <DeleteIcon />
                  </button>
                ) : (
                  <p></p>
                )}
              </Box>
            </Box>
            <Container>
              <Box className="loadingUnloadingHeading">
                <Box className="loadingUnloadingHeading1">
                  <Typography variant="span">
                    <HomeIcon />
                  </Typography>
                  <Typography variant="h6">From</Typography>
                </Box>
                <Box className="loadingUnloadingHeading2">
                  <Typography variant="h6">To</Typography>
                </Box>
                <Box className="loadingUnloadingHeading3">
                  <Typography variant="span">
                    <AddIcon onClick={handleIncrementLoadingUnloading} />
                  </Typography>
                </Box>
              </Box>
            </Container>
            <Container>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={4} md={4}>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Location
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Loading Method
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Equipment Required
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Site Inspection
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Name
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Number
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="locationFrom"
                      label="Location"
                      variant="outlined"
                      required
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        required
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="loadingMethodFrom"
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value="Top">Top</option>
                        <option value="Side">Side</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        required
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="equipmentRequiredFrom"
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        required
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="siteInspectionFrom"
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="contactPersonNameFrom"
                      label="Name"
                      required
                      variant="outlined"
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="PhoneNumberFrom"
                      label="Phone Number"
                      variant="outlined"
                      required
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4} md={4}>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="locationTo"
                      label="Location"
                      variant="outlined"
                      required
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        required
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="loadingMethodTo"
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value="Top">Top</option>
                        <option value="Side">Side</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        required
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="equipmentRequiredTo"
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        required
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="siteInspectionTo"
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="contactPersonNameTo"
                      label="Name"
                      required
                      variant="outlined"
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="PhoneNumberTo"
                      label="Phone Number"
                      variant="outlined"
                      required
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        ))}
      </>
      <>
        {loadingUnLoadingCount?.map((item, i) => (
          <Box className="loadingUnloadingDetalis mobile" key={i}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
                padding: "15px 10px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "10px",
                }}
              >
                <Typography variant="span">
                  <HomeIcon />
                </Typography>
                <Typography variant="h6">
                  Loading And UnLoading Details
                </Typography>
              </Box>
              <Box>
                {i !== 0 ? (
                  <button
                    className="quote_loadingUn_btn"
                    onClick={() => handleLoadingUnloadDelete(i)}
                  >
                    <DeleteIcon />
                  </button>
                ) : (
                  <p></p>
                )}
              </Box>
            </Box>
            <Container>
              <Box className="loadingUnloadingHeading">
                <Box className="loadingUnloadingHeading1">
                  <Typography variant="span">
                    <HomeIcon />
                  </Typography>
                  <Typography variant="h6">From</Typography>
                </Box>
                <Box className="loadingUnloadingHeading2">
                  <Typography variant="h6">To</Typography>
                </Box>
                <Box className="loadingUnloadingHeading3">
                  <Typography variant="span">
                    <AddIcon onClick={handleIncrementLoadingUnloading} />
                  </Typography>
                </Box>
              </Box>
            </Container>
            <Container>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={4} md={4}>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Location
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="locationFrom"
                          label="Location"
                          variant="outlined"
                          required
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="locationTo"
                          label="Location"
                          variant="outlined"
                          required
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Loading Method
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            required
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="loadingMethodFrom"
                          >
                            <option
                              aria-label="None"
                              value=""
                              selected
                              disabled
                            >
                              Please select
                            </option>
                            <option value="Top">Top</option>
                            <option value="Side">Side</option>
                          </Select>
                        </FormControl>
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            required
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="loadingMethodTo"
                          >
                            <option
                              aria-label="None"
                              value=""
                              selected
                              disabled
                            >
                              Please select
                            </option>
                            <option value="Top">Top</option>
                            <option value="Side">Side</option>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Equipment Required
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            required
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="equipmentRequiredFrom"
                          >
                            <option
                              aria-label="None"
                              value=""
                              selected
                              disabled
                            >
                              Please select
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Select>
                        </FormControl>
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            required
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="equipmentRequiredTo"
                          >
                            <option
                              aria-label="None"
                              value=""
                              selected
                              disabled
                            >
                              Please select
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Site Inspection
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            required
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="siteInspectionFrom"
                          >
                            <option
                              aria-label="None"
                              value=""
                              selected
                              disabled
                            >
                              Please select
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Select>
                        </FormControl>
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            required
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="siteInspectionTo"
                          >
                            <option
                              aria-label="None"
                              value=""
                              selected
                              disabled
                            >
                              Please select
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    {" "}
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Name
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="contactPersonNameFrom"
                          label="Name"
                          required
                          variant="outlined"
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="contactPersonNameTo"
                          label="Name"
                          required
                          variant="outlined"
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Number
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="PhoneNumberFrom"
                          label="Phone Number"
                          variant="outlined"
                          required
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="PhoneNumberTo"
                          label="Phone Number"
                          variant="outlined"
                          required
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        ))}
      </>
    </>
  );
};

export default LoadingAndUnLoading;
